var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStethoscope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66536 2.33313C4.04236 2.33313 3.45546 2.57572 3.01563 3.01672C2.57463 3.45772 2.33203 4.04463 2.33203 4.66646V8.16646C2.33203 11.5988 4.46709 14.5299 7.47494 15.7338C7.88775 16.452 8.54065 17.0045 9.33203 17.2856V20.9998C9.33203 23.577 11.4215 25.6665 13.9987 25.6665H18.6654C21.2425 25.6665 23.332 23.577 23.332 20.9998V20.797C24.014 20.5559 24.6045 20.1094 25.0223 19.519C25.4402 18.9285 25.6648 18.2231 25.6654 17.4998C25.6654 16.5715 25.2966 15.6813 24.6402 15.0249C23.9839 14.3685 23.0936 13.9998 22.1654 13.9998C21.2371 13.9998 20.3469 14.3685 19.6905 15.0249C19.0341 15.6813 18.6654 16.5715 18.6654 17.4998C18.6664 18.2227 18.8912 18.9276 19.309 19.5176C19.7268 20.1076 20.3171 20.5537 20.9987 20.7947V20.9998C20.9987 22.289 19.9545 23.3331 18.6654 23.3331H13.9987C12.7095 23.3331 11.6654 22.289 11.6654 20.9998V17.2856C12.4567 17.0045 13.1096 16.452 13.5225 15.7338C16.5303 14.5288 18.6654 11.593 18.6654 8.13912V4.66646C18.6654 3.3773 17.6212 2.33313 16.332 2.33313H15.1654C14.5214 2.33313 13.9987 2.8558 13.9987 3.4998C13.9987 4.1438 14.5214 4.66646 15.1654 4.66646H16.332V7.9067C16.332 10.9505 14.1141 13.675 11.0843 13.9702C10.8669 13.9915 10.6498 14.002 10.4372 13.9998C7.24853 13.9675 4.66655 11.3613 4.66764 8.13912L4.66536 4.66646H5.83203C6.47603 4.66646 6.9987 4.1438 6.9987 3.4998C6.9987 2.8558 6.47603 2.33313 5.83203 2.33313H4.66536Z",
    fill: "#6D39D9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscope);
export default __webpack_public_path__ + "static/media/stethoscope.dc8b8b642d37879446da289ad0e3c897.svg";
export { ForwardRef as ReactComponent };